import type { MobileStripBandSettings } from "../../mobileStripBandSettings"
import type { BandSvgArt } from "./bandSvgLayers"

// Solid-fill band slices plus the boundary edge stroke ("solid" fill
// style only — the dither field is the canvas layer). Both dim together
// while the choice-point fan is up, on the fan's fade clock.
export const RiskBandSolidFill = ({
  art,
  band,
  opacity,
  fadeMs,
}: {
  art: BandSvgArt
  band: MobileStripBandSettings
  opacity: number
  fadeMs: number
}) => (
  <g style={{ opacity, transition: `opacity ${fadeMs}ms ease-in-out` }}>
    {art.layers.map((layer, layerIndex) => (
      <path
        key={layerIndex}
        d={layer.d}
        fill={band.ditherColor}
        fillOpacity={layer.fillOpacity}
      />
    ))}
    {band.bandEdgeStrokeWidthPx > 0 && (
      <path
        d={art.bottomEdgePath}
        stroke={band.ditherColor}
        strokeWidth={band.bandEdgeStrokeWidthPx}
        fill="none"
      />
    )}
  </g>
)
